import type { InjectionKey, Ref } from 'vue'

export interface PendingRefocus {
  levelFieldKey: string
  cursor: number | null
}

export const pendingRefocusKey: InjectionKey<Ref<PendingRefocus | null>> = Symbol('pendingRefocus')
